import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCheck } from '@fortawesome/free-solid-svg-icons';
import close from '../assets/img/closeButton.svg'
import tick from '../assets/img/tick.svg'


// const searchKeyPress = (e, v) => {
//     console.log(e.keyCode, v)
//     if (e.keyCode === 13)
//     {
//         return pressNumkey(v);
//     }
//     return false;
// }

const Numkey = (props) => {
    return (
        <button className="btn-numkey"
            onMouseDown={(e) => props.pressNumkey(props.value)}
            onKeyDown={(e) => e.keyCode === 13 ? props.pressNumkey(props.value) : null}
        >
            <p>{props.value}</p>
        </button>
    )
}

const DelKey = (props) => {
    const element = <FontAwesomeIcon icon={faTimes} />
    return(
        <button className="btn-numkey del"
            onMouseDown={() => props.pressDelKey()}
            onKeyDown={(e) => e.keyCode === 13 ? props.pressDelKey() : null}
        >
            <img alt="null" src={close}></img>
        </button>
    );
}

const Enter = (props) => {
    const element = <FontAwesomeIcon icon={faCheck} />
    return(
        <button aria-label="enter" 
        onClick={props.pressEnterKey} 
        className="btn-numkey ok"
        onKeyDown={() => props.pressEnterKey}
        >
            <img alt="null" src={tick}></img>
        </button>
    )
}

export default function Numpad(props) {
    return(

        <div className="numpad-wrapper">
            <div className="numpad">
                {/* <div className="top-banner"></div> */}
                <Numkey pressNumkey={(value) => props.pressNumkey(value)} value={1} />
                <Numkey pressNumkey={(value) => props.pressNumkey(value)} value={2} />
                <Numkey pressNumkey={(value) => props.pressNumkey(value)} value={3} />
                <Numkey pressNumkey={(value) => props.pressNumkey(value)} value={4} />
                <Numkey pressNumkey={(value) => props.pressNumkey(value)} value={5} />
                <Numkey pressNumkey={(value) => props.pressNumkey(value)} value={6} />
                <Numkey pressNumkey={(value) => props.pressNumkey(value)} value={7} />
                <Numkey pressNumkey={(value) => props.pressNumkey(value)} value={8} />
                <Numkey pressNumkey={(value) => props.pressNumkey(value)} value={9} />
                <DelKey pressDelKey={() => props.pressDelKey()} />
                <Numkey pressNumkey={(value) => props.pressNumkey(value)} value={0} />
                <Enter pressEnterKey={props.pressEnterKey} />
            </div>
        </div>

    );
}
